import { assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class RequestWordsWithRelatedWordsTranslateFromEnglish extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_WORD_WITH_RELATED_WORDS_TRANSLATE_FROM_ENGLISH;

  language!: string;
  words_english!: string[];

  /*
   * METHODS
   */
  constructor() {
    super();

    this.words_english = [];
  }

  assert_standard_fields(): void {
    assert_type_enum(this.language, ENUM__language_type);
  }
}
